// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ArticlePublishDate_wrapper__XSK2D","wrapper__textOnly":"ArticlePublishDate_wrapper__textOnly__nZmRp","calendarIcon":"ArticlePublishDate_calendarIcon__jdO_J"};